import React from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import ReactMarkdown from 'react-markdown';
import { Button } from 'react-toolbox/lib/button';

export default class MenuItem extends React.Component {
    render() {
        const { menuItem, disabled = false, onClick = () => { } } = this.props;
        const style = {
            'flex': '1 1 31.4%',
            'margin': '4px',
            'height': 'auto',
            'minHeight': '65px',
            'maxHeight': '50%',
            'lineHeight': '1.3',
            'wordWrap': 'breakWord',
            'whiteSpace': 'normal',
            'textTransform': 'none',
            'color': menuItem.foreground,
            'backgroundColor': menuItem.color
        };
        return (
            <Button
                style={style}
                raised
                disabled={disabled}
                onClick={onClick.bind(
                    null,
                    menuItem.productId,
                    menuItem.defaultOrderTags,
                    menuItem.automationCommand
                )}
            >
                <ReactMarkdown className="buttonContent" source={menuItem.caption} />
            </Button>
        );
    }
} 



// WEBPACK FOOTER //
// ./app/components/Menu/MenuItem.jsx